import { blockInternal, blockEcommerce } from "@/middleware";

const CatalogView = () => import("./CatalogView.vue");
const CatalogsView = () => import("./CatalogsView.vue");

const catalogRoutes = [
  {
    path: "/catalogs",
    name: "Catalogs",
    component: CatalogsView,
    meta: {
      middleware: [blockInternal, blockEcommerce]
    }
  },
  {
    path: "/catalogs/:catalogId",
    name: "Catalog",
    component: CatalogView,
    props: true,
    meta: {
      middleware: [blockInternal, blockEcommerce]
    }
  },
  {
    path: "/catalogs/retail",
    name: "CatalogRetail",
    component: CatalogView,
    props: { catalogId: import.meta.env.VITE_CATALOG_RETAIL_ID },
    meta: {
      middleware: [blockInternal, blockEcommerce]
    }
  },
  {
    path: "/catalogs/education",
    name: "CatalogEducation",
    component: CatalogView,
    props: { catalogId: import.meta.env.VITE_CATALOG_EDUCATION_ID },
    meta: {
      middleware: [blockInternal, blockEcommerce]
    }
  }
];

export default catalogRoutes;
